/**
 * GROQ fragments for author bio locale matching and "has content" checks.
 *
 * After sanity-plugin-internationalized-array v5, bio items use a `language` field
 * instead of locale-as-`_key`. Studio can also create empty locale placeholders
 * (language set, no `value`) ahead of migrated entries — always pick the first item
 * that actually has portable text, not merely the first locale match.
 */

/** Match internationalized-array items by v5 `language` or legacy v4 `_key`. */
export const authorBioLocaleMatch = `(language == $locale || _key == $locale)`;

/** True when a bio array item has non-empty portable text. */
export const authorBioHasContent = `count(value[children[].text match "?*"]) > 0`;

/** First bio entry for $locale that has content (projection root, e.g. `"bio": …`). */
export const authorBioForLocale = `bio[${authorBioLocaleMatch} && ${authorBioHasContent}][0]`;

/** Document filter: author has a publishable bio for $locale. */
export const authorHasBioForLocale = `count(bio[${authorBioLocaleMatch} && ${authorBioHasContent}]) > 0`;

/** Locales with bio content (for sitemap hreflang). Prefer `language`, fall back to legacy `_key`. */
export const authorBioLocales = `bio[${authorBioHasContent}]{"locale": coalesce(language, _key)}.locale`;
